import { render } from "./ProductivityChart.vue?vue&type=template&id=69c5ab02"
import script from "./ProductivityChart.vue?vue&type=script&lang=js"
export * from "./ProductivityChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__